<template>
  <div
    ref="contentModal"
    aria-hidden="true"
    aria-labelledby="alertModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title textStyle">{{ $tc("registration.alert.title", 2) }}</h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <FormCollapseAlertComponent
            v-for="(alert, index) in alerts"
            :key="index"
            :index="index"
            :alert="alert"
            :name="name"
            :alertLength="alerts.length"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormCollapseAlertComponent from "@/components/form/alert/FormCollapseAlertComponent.vue";
import { modalMixin } from "@/mixins/modalMixin";

export default {
  name: "FormAlertsModalComponent",
  components: { FormCollapseAlertComponent },
  mixins: [modalMixin],
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    alerts: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  emits: ["hidden"],
  watch: {
    opened() {
      if (this.opened) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
